import { render, staticRenderFns } from "./Testimoni.vue?vue&type=template&id=69d75962&"
import script from "./Testimoni.vue?vue&type=script&lang=js&"
export * from "./Testimoni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports